import { GridColumn, GridRow } from 'app/member/layouts/grid';
import { Button } from 'app/shared/button';
import { DateTimePicker } from 'app/shared/datepickers';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { MultiSelect } from 'app/shared/select';
import { useModuleService } from 'hooks/api/sales/module';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const PERIODS = [
  { label: 'Monthly', value: 'month' },
  { label: 'Yearly', value: 'year' }
];

export const DiscountWidget = ({ module = {} }) => {
  const { updateModule } = useModuleService();

  const [module_data, setModuleData] = useState({});
  const [selected_period, setSelectedPeriod] = useState(PERIODS[0]);
  const [percentage, setPercentage] = useState(0);
  const [expires_at, setExpiresAt] = useState(null);

  const [is_saving, setIsSaving] = useState(false);

  useEffect(() => {
    if (module && Object.keys(module).length) {
      setModuleData(module);
    }
  }, [module]);

  useEffect(() => {
    if (!module_data || !Object.keys(module_data).length) return;
    const {
      pricing: [first_pricing]
    } = module_data;
    const { discounts } = first_pricing;

    const discount_for_period = (discounts || {})[selected_period.value] || {};
    setPercentage(discount_for_period.value || 0);
    setExpiresAt(new Date(discount_for_period.expires_at || Date.now()));
  }, [module_data, selected_period.value]);

  const submit = async () => {
    if (!module_data || !Object.keys(module_data).length)
      return toast.error('Module data is required');
    if (!selected_period.value || isNaN(percentage) || !expires_at)
      return toast.error('All fields are required');

    const new_pricing = module_data.pricing.map((pricing) => {
      return {
        ...pricing,
        discounts: {
          ...(pricing.discounts || {}),
          [selected_period.value]: {
            value: Number(percentage),
            expires_at: Date.parse(expires_at)
          }
        }
      };
    });

    const data = { pricing: new_pricing };
    setIsSaving(true);
    await updateModule(module_data.id, { data });
    setModuleData({ ...module_data, ...data });
    setIsSaving(false);
  };

  return (
    <div>
      <GridRow num_of_columns={3}>
        <GridColumn>
          <DetailItem title="Period">
            <MultiSelect options={PERIODS} value={selected_period} onChange={setSelectedPeriod} />
          </DetailItem>
        </GridColumn>
        <GridColumn>
          <DetailItem title="Percentage">
            <SimpleInput type="number" value={percentage} onInput={setPercentage} />
          </DetailItem>
        </GridColumn>
        <GridColumn>
          <DetailItem title="Expires At">
            <DateTimePicker value={expires_at} onChange={setExpiresAt} />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={2}>
        <GridColumn />
        <GridColumn>
          <Button disabled={is_saving} loading={is_saving} onClick={submit} text="Apply Discount" />
        </GridColumn>
      </GridRow>
    </div>
  );
};
